interface FormatOptions {
  style: "currency" | "decimal" | "percent";
  currency?: string;
  minimumFractionDigits?: number;
}

const formatToMoney = (number: number, options: FormatOptions): string => {
  const { style, currency = "BRL", minimumFractionDigits = 2 } = options;

  return new Intl.NumberFormat("pt-BR", {
    style,
    currency,
    minimumFractionDigits,
  }).format(number);
};

const formatCurrency = (price: number, isAdvance?: boolean): string =>
  formatToMoney(isAdvance ? -price : price, { style: "currency" });

const formatFromInput = (value: string): number => {
  const newValue = value
    .replace(/[^0-9.,-]/g, "")
    .replace(/\./g, "")
    .replace(/,/g, ".");

  return parseFloat(newValue) ? parseFloat(newValue) : 0;
};

export { formatCurrency, formatFromInput, formatToMoney };
